export const PromoVariant = {
  SMALL_PROMO: 0,
  PROMO_AREA: 1,
};

export const PromoStyle = {
  STYLE_1: 1,
  STYLE_2: 2,
  STYLE_3: 3,
};
